
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class TaskTypePropertiesDialog extends SiteEntityDialog<TaskTypePropertiesRow, any> {
        protected getFormKey() { return TaskTypePropertiesForm.formKey; }
        protected getIdProperty() { return TaskTypePropertiesRow.idProperty; }
        protected getLocalTextPrefix() { return TaskTypePropertiesRow.localTextPrefix; }
        protected getNameProperty() { return TaskTypePropertiesRow.nameProperty; }
        protected getService() { return TaskTypePropertiesService.baseUrl; }

        protected form = new TaskTypePropertiesForm(this.idPrefix);

    }
}